/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmissionFeatureUIDTOV0 } from './emissionFeatureUIDTOV0';
import { EnergyFeatureUIDTOV0 } from './energyFeatureUIDTOV0';


export interface SAPSpecialFeatureUIDTOV0 { 
    Description?: string;
    energyFeature?: EnergyFeatureUIDTOV0;
    emissionsFeature?: EmissionFeatureUIDTOV0;
}

